import { useEffect, useState } from 'react';

const START_SECONDS = 17 * 60 + 34;

export function useCountdown() {
  const [seconds, setSeconds] = useState(START_SECONDS);

  useEffect(() => {
    const id = window.setInterval(() => {
      setSeconds((prev) => (prev <= 1 ? START_SECONDS : prev - 1));
    }, 1000);
    return () => window.clearInterval(id);
  }, []);

  return {
    hours: Math.floor(seconds / 3600),
    minutes: Math.floor((seconds % 3600) / 60),
    seconds: seconds % 60,
  };
}
